export const findDeepestObjectKey = <T extends { [key: string]: T }>(
	obj: T,
	keyToFind: string = "Parent"
): T | null => {
	let deepestParent: T | null = null;
	let maxDepth = -1;
	let lastNonNullParent: T | null = null; // Track last non-null parent

	function traverse(node: T, depth = 0) {
		for (const key in node) {
			if (key === keyToFind) {
				if (node[key] !== null && node[key] !== undefined) {
					lastNonNullParent = node[key];
					if (depth > maxDepth) {
						maxDepth = depth;
						deepestParent = node[key];
					}
				} else if (depth > maxDepth) {
					maxDepth = depth;
					deepestParent = null;
				}
			}
			if (node[key] !== null && typeof node[key] === "object") {
				traverse(node[key] as T, depth + 1);
			}
		}
	}

	traverse(obj);
	return deepestParent === null ? lastNonNullParent : deepestParent;
};
